const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  image: "https://www.venturawebdesign.com/ventura-og.png",
  url: "https://www.venturawebdesign.com",
  logo: "https://www.venturawebdesign.com/ventura-logo.png",
  name: "Ventura Web Design & Marketing",
  description: "Ventura Web Design & Marketing is a web design company and digital marketing agency that designs, builds, and markets professional ecommerce mobile-ready websites.",
  email: "support@venturawebdesign.com",
  telephone: "+1-813-556-7990",
  address: {
    "@type": "PostalAddress",
    streetAddress: "1810 W Kennedy Blvd Ste 323",
    addressLocality: "Tampa",
    addressRegion: "FL",
    postalCode: "33606",
    addressCountry: "US",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1-813-556-7990",
    email: "support@venturawebdesign.com",
  },
  foundingDate: "19691231T190001.997-0500",
};

export default orgSchema;
